import { forwardRef } from "react";
import { KNIT_NEEDLES } from "@/content";
import { KnitAnimation, type KnitAnimationHandle, type SceneFactory } from "./KnitAnimation";
import { PASS_SECONDS, stepSeconds } from "./needleCycle";

// The loop runs two passes, one each way, so it can repeat without a seam.
const LOOP_SECONDS = 2 * PASS_SECONDS;

// Without motion, the bed rests mid-pass: the middle needle's latch just shut over the new yarn.
const STILL_SECONDS = stepSeconds(0, 2);

// The next time the middle needle starts a step, in the pass under way.
const stepAt = (seconds: number, step: number) => stepSeconds(Math.floor(seconds / PASS_SECONDS), step);

const load = (): Promise<SceneFactory> => import("./needleScene").then((module) => module.createNeedleScene);

export type NeedleBedHandle = KnitAnimationHandle;

type NeedleBedProps = {
  readonly onStepChange: (step: number) => void;
};

// Latch needles knitting a course as the carriage passes, drawn in 3D.
export const NeedleBed = forwardRef<NeedleBedHandle, NeedleBedProps>(({ onStepChange }, ref) => (
  <KnitAnimation
    ref={ref}
    load={load}
    loopSeconds={LOOP_SECONDS}
    stillSeconds={STILL_SECONDS}
    stepAt={stepAt}
    still={KNIT_NEEDLES.still}
    description={KNIT_NEEDLES.description}
    onStepChange={onStepChange}
  />
));

NeedleBed.displayName = "NeedleBed";
